// Configuration for Flamingo Reading Tracker API

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_LOCAL_URL = process.env.REACT_APP_API_LOCAL_URL;
const API_AUTHORIZATION_KEY = process.env.REACT_APP_API_AUTHORIZATION_KEY;

export { API_BASE_URL, API_LOCAL_URL, API_AUTHORIZATION_KEY };
